import {ascending, descending} from "d3-array";

export abstract class SortableTable implements ng.IDirective {
    restrict = 'E';
    scope = {
        tableRows: '='
    };
    replace: true;
    abstract template;
    link = function($scope: ng.IScope, elements: any, attrs: any) {
        let sortBy = 'proportion';
        let sortDirection = ascending;

        const update = () => {
            (<any> $scope).sortedTableRows = [...((<any> $scope).tableRows || [])]
                .sort((a, b) => sortDirection(a[sortBy], b[sortBy]));
        };

        $scope['sortBy'] = (column: string) => {
            if (sortBy === column) {
                sortDirection = sortDirection === ascending ? descending : ascending;
            }
            sortBy = column;
            update();
        };

        $scope.$watch('tableRows', update);
        update();
    };
}